
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>News</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">News</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWNews">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWNewsList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">

                      <div class="form-group">
                        <label class="control-label">Role</label>
                        <select id="role_id" name="role_id" v-model="value.role_id" class="form-control">
                          <option disabled value="">Select Role</option>
                          <option v-for="role in roles" :key="role.id" :value="role.id">
                            {{ role.name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group required" >
              <label class="control-label">Title</label>
              <input type="text" id="title" name="title"
                     v-bind:class="{'has-error' : errors.has('title')}"
                     v-validate="'required'"
                     v-model="value.title" class="form-control title"
                     placeholder="Title">
              <div class="help text-danger" v-show="errors.has('title')">
                {{ errors.first("title") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">News Details</label>
              <textarea id="news_details" name="news_details"
                 v-bind:class="{'has-error' : errors.has('news_details')}"
                 v-validate="'required'"
                 v-model="value.news_details" class="form-control news_details"
                 placeholder="News Details"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('news_details')">
                {{ errors.first("news_details") }}
              </div>
            </div>
                    <div class="col-md-12" >
                        <h4 class="site-heading my-3"><span>Image</span></h4>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="image"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input type="file"


                                name="image" class="custom-file-input" id="image" @change="select_file_image">
                                <label class="custom-file-label" for="image">{{ value.image }}</label>
                              </div>
                            </div>
                            <small class="form-text text-muted"> <strong>Dimension of the image should be: 746 x 374 px</strong> </small>
                          </div>

                        </div>
                    </div>

            <div class="form-group " >
              <label class="control-label">Link</label>
              <input type="text" id="link" name="link"


                     v-model="value.link" class="form-control link"
                     placeholder="Link">

            </div>
            <div class="form-group " >
              <label class="control-label">View Count</label>
              <input type="text" id="view_count" name="view_count"


                     v-model="value.view_count" class="form-control view_count"
                     placeholder="View Count" readonly>

            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWNewsForm',
  metaInfo: {
    title: 'News | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    roles: [
      { id: 0, name: "All User" },
      { id: 1, name: "Administrator" },
      { id: 2, name: "Business" },
      { id: 3, name: "Agent" },
      { id: 4, name: "Merchant" },
      { id: 5, name: "General User" },
      { id: 6, name: "Support" },
      { id: 7, name: "Bank" },
      { id: 8, name: "Business Admin" },
    ],

    value: {
        image: '',
        image_name: 'Choose file',
        view_count: 0,
        role_id: '',


    },
    pre: {

    }
  }),
  methods: {
    select_file_image: function (event) {
      try {
        const file = event.target.files[0]
        if (!file) return

        const reader = new FileReader()
        const img = new Image()

        reader.onload = (e) => {
          img.src = e.target.result
        };

        img.onload = () => {
          const hiddenImg = document.createElement('img')
          hiddenImg.src = img.src
          hiddenImg.style.width = '746px'
          hiddenImg.style.height = '374px'
          hiddenImg.style.visibility = 'hidden'

          document.body.appendChild(hiddenImg)
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          hiddenImg.onload = () => {
            canvas.width = 746
            canvas.height = 374

            ctx.drawImage(hiddenImg, 0, 0, 746, 374)
            this.value.image = canvas.toDataURL('image/jpeg')
            this.$set(this.value, 'image_name', file.name)
            document.body.removeChild(hiddenImg)
          };
        };

        reader.readAsDataURL(file)
      } catch (e) {
        console.log(e)
      }
    },
    handleSubmission () {
      let _this = this;
      if (!this.value.role_id) this.value.role_id = 0;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_news'
          let method = 'POST'
          let data = { ..._this.value }

          if (_this.is_edit && !_this.value.image_name) {
            delete data.image;
          }
          if (_this.is_edit) {
            api_url = '/ew_news/' + _this.$route.params.id
            method = 'PUT'
          }

          console.log(data)

          axios({
            method: method,
            url: api_url,
            data: data,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWNewsList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_news/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
          if (this.value.image) {
            this.value.image = response.data.image
          }
        }).catch((error) => {
          console.log(error.response)
        })

      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

